import { render, staticRenderFns } from "./MobileVersion.vue?vue&type=template&id=035978b1&scoped=true"
import script from "./MobileVersion.vue?vue&type=script&lang=js"
export * from "./MobileVersion.vue?vue&type=script&lang=js"
import style0 from "./MobileVersion.vue?vue&type=style&index=0&id=035978b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035978b1",
  null
  
)

export default component.exports